import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DeclineDialogContractStateService {
  private declineDialogStatusSubject = new Subject<any>();

  constructor() { }

  triggerDialogStatus(data: any) {
    this.declineDialogStatusSubject.next(data);
  }

  handleDialogStatus(): Observable<any> {
    return this.declineDialogStatusSubject.asObservable();
  }

}




// WEBPACK FOOTER //
// ./src/app/components/dashboard/for-signing/decline/decline.dialog.state.service.ts